import React from 'react'
import CountUp, { useCountUp } from 'react-countup';

export default function HomeCounter({countData}) {
  useCountUp({
    ref: "counter",
    start: 0,
    end: 1234567,
    delay: 1000,
    duration: 3000,
  });
  return (
    <>
      <section className="home-count-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="heading center-heading">Driving Measurable Business Impact</h2>
            </div>
            {countData?.map((data, index) => (
              <div key={index} className="col-lg-3 col-md-3">
                <div className="home-counts">
                  <span><CountUp end={data?.number} enableScrollSpy/>{data?.suffix}</span>
                  <p dangerouslySetInnerHTML={{__html: data?.desc}}/>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
